import { assignedLicensesFeatureList } from 'utils/license-helpers';

import { InitialState, actionTypes } from './UserDrawerContext';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_BASE_ASSIGNED_TEAMS:
      state.baseAssignedTeams = action.baseAssignedTeams;

      return;
    case actionTypes.SET_ASSIGNED_TEAMS:
      state.assignedTeams = action.assignedTeams;

      return;
    case actionTypes.SET_BASE_ASSIGNED_LICENSES:
      state.baseAssignedLicenses = action.baseAssignedLicenses;

      return;
    case actionTypes.SET_ASSIGNED_LICENSES:
      state.assignedLicenses = action.assignedLicenses;

      return;
    case actionTypes.SET_LICENSES_TO_ADD:
      state.licensesToAdd = action.licensesToAdd;

      return;
    case actionTypes.REMOVE_LICENSE: {
      const { assignedLicenses: assigned } = state;
      const { licensesToAdd: toAdd } = state;
      const { license } = action;

      // check if removed license is a voice license
      const licenseFeatures = assignedLicensesFeatureList([license]);
      const isLicenseVoice = licenseFeatures.some(
        (f) => f === 'PLATFORM_VOICE_ACCESS',
      );

      // if there is a voice license in the remaining assigned licenses
      const licenses = [...assigned, ...toAdd].filter(
        (l) => l.id !== license.id,
      );
      const isLicensesFeatures = assignedLicensesFeatureList(licenses);
      const isLicensesVoice = isLicensesFeatures.some(
        (f) => f === 'PLATFORM_VOICE_ACCESS',
      );

      // if the license getting removed is a voice license and
      // a voice license doesn't remain in assigned licenses
      if (isLicenseVoice && !isLicensesVoice) {
        state.removedVoiceAccess = true;

        return;
      }
      if (assigned.length === 0 && toAdd.length === 0) {
        state.removedNextOsAccess = true;
      }

      return;
    }
    case actionTypes.ADD_LICENSE: {
      const { removedVoiceAccess } = state;
      const { license } = action;
      // if license is a voice license
      const licenseFeatures = assignedLicensesFeatureList([license]);
      const isLicenseVoice = licenseFeatures.some(
        (f) => f === 'PLATFORM_VOICE_ACCESS',
      );

      if (isLicenseVoice && removedVoiceAccess) {
        state.removedVoiceAccess = false;
      }
      state.removedNextOsAccess = false;

      return;
    }
    case actionTypes.SET_LICENSES_LOADING:
      state.isLicensesLoading = action.isLicensesLoading;

      return;
    case actionTypes.SET_TEAMS_LOADING:
      state.isTeamsLoading = action.isTeamsLoading;

      return;
    default:
      return InitialState;
  }
};
